import { ExternalLink } from 'lucide-react'
import { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchCmsContent, fetchCmsVersions, formatDateTime } from '../lib/cms'
import { fetchShuttleContent, fetchShuttleVersions } from '../lib/shuttleCms'
import { fetchCampusGraphContent, fetchCampusGraphVersions } from '../lib/campusGraphCms'

const CMS_ENTRIES = [
  { contentType: 'faq', label: 'FAQ', to: '/faq' },
  { contentType: 'homeConfig', label: '홈 화면', to: '/home-config' },
  { contentType: 'buildings', label: '건물', to: '/map' },
  { contentType: 'facilities', label: '시설', to: '/map' },
  { contentType: 'cafeteriaOverrides', label: '학식 override', to: '/cafeteria-notice' },
  { contentType: 'noticeOverrides', label: '공지 override', to: '/cafeteria-notice' },
  { contentType: 'featureSettings', label: '기능 설정', to: '/feature-settings' },
]

export default function DataVersionsPage() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [expanded, setExpanded] = useState(null)
  const [historyByKey, setHistoryByKey] = useState({})

  async function load() {
    setLoading(true); setError('')
    try {
      const cmsRows = await Promise.all(CMS_ENTRIES.map(async entry => {
        const { production, draft } = await fetchCmsContent(entry.contentType)
        return { key: entry.contentType, label: entry.label, to: entry.to, version: production?.version ?? 0, publishedAt: production?.publishedAt ?? null, publishedBy: production?.publishedBy ?? null, hasDraft: Boolean(draft) }
      }))
      const shuttle = await fetchShuttleContent()
      const graph = await fetchCampusGraphContent()
      setRows([
        ...cmsRows,
        { key: 'shuttle', label: '셔틀', to: '/shuttle', version: shuttle.production?.version ?? '없음', publishedAt: shuttle.production?.publishedAt ?? null, publishedBy: shuttle.production?.publishedBy ?? null, hasDraft: Boolean(shuttle.draft) },
        { key: 'campusGraph', label: '보행 그래프', to: '/map', version: graph.productionManifest?.version ?? '없음', publishedAt: graph.productionManifest?.publishedAt ?? null, publishedBy: graph.productionManifest?.publishedBy ?? null, hasDraft: Boolean(graph.draftManifest) },
      ])
    } catch (err) { setError(err.message) } finally { setLoading(false) }
  }
  useEffect(() => { load() }, [])

  async function toggleHistory(key) {
    if (expanded === key) { setExpanded(null); return }
    setExpanded(key)
    if (historyByKey[key]) return
    try {
      const versions = key === 'shuttle' ? await fetchShuttleVersions()
        : key === 'campusGraph' ? await fetchCampusGraphVersions()
        : await fetchCmsVersions(key)
      setHistoryByKey(current => ({ ...current, [key]: versions }))
    } catch (err) { setError(err.message) }
  }

  if (loading) return <div className="empty-state">데이터 버전을 불러오는 중…</div>
  return (
    <>
      <header className="page-header"><div><p className="eyebrow">시스템</p><h1>데이터 배포</h1><p>현재 서비스에 사용 중인 데이터와 마지막 배포를 확인합니다. 수정과 배포는 각 관리 화면에서 진행합니다.</p></div></header>
      {error && <div className="error-state">{error}</div>}
      <section className="panel table-wrap">
        <table className="data-table"><thead><tr><th>콘텐츠</th><th>production 버전</th><th>배포일시</th><th>배포자</th><th>초안</th><th /></tr></thead><tbody>
          {rows.map(row => (
            <Fragment key={row.key}>
              <tr onClick={() => toggleHistory(row.key)}>
                <td>{row.label}</td>
                <td>{row.version === 0 ? '없음' : `v${row.version}`}</td>
                <td>{row.publishedAt ? formatDateTime(row.publishedAt) : '—'}</td>
                <td>{row.publishedBy || '—'}</td>
                <td>{row.hasDraft ? <span className="status-badge new">초안 있음</span> : <span className="muted">없음</span>}</td>
                <td><Link className="icon-button" to={row.to} onClick={e => e.stopPropagation()} aria-label="관리 화면으로"><ExternalLink size={16} /></Link></td>
              </tr>
              {expanded === row.key && (
                <tr><td colSpan={6}>
                  {!historyByKey[row.key] ? <div className="empty-state">이력을 불러오는 중…</div> : historyByKey[row.key].length === 0 ? <div className="empty-state">배포 이력이 없습니다.</div> : (
                    <div className="data-list">
                      {historyByKey[row.key].map(v => <div className="data-row" key={v.version}><div><strong>v{v.version}</strong><small>{v.publishedBy || v.createdBy}{v.note ? ` · ${v.note}` : ''}</small></div><time>{formatDateTime(v.publishedAt || v.createdAt)}</time></div>)}
                    </div>
                  )}
                </td></tr>
              )}
            </Fragment>
          ))}
        </tbody></table>
      </section>
    </>
  )
}
